import { API_URL } from "../../config";
import store from "../store";

export default {
  namespaced: true,

  state: {
    reparaciones: {
      loading: false,
      error: null,
      permisos: { lectura: false, gestion: false, repuestos: false, gestorRepuestos: false, destinatarios: false },
      sucursales: [],
      recibidos: [],
      espera_repuestos: [],
      agendado: [],
      terceros: [],
      en_proceso: [],
      finalizados: [],
    },
  },

  mutations: {
    SET_REPARACIONES_LOADING(state, bool) {
      state.reparaciones.loading = bool;
    },
    SET_REPARACIONES_ERROR(state, msg) {
      state.reparaciones.error = msg;
    },
    SET_REPARACIONES_PERMISOS(state, permisos) {
      state.reparaciones.permisos = {
        lectura: !!(permisos && permisos.lectura),
        gestion: !!(permisos && permisos.gestion),
        repuestos: !!(permisos && permisos.repuestos),
        gestorRepuestos: !!(permisos && permisos.gestorRepuestos),
        destinatarios: !!(permisos && permisos.destinatarios),
      };
    },
    SET_REPARACIONES_SUCURSALES(state, sucursales) {
      state.reparaciones.sucursales = Array.isArray(sucursales)
        ? sucursales.map(Number).filter((n) => Number.isInteger(n) && n > 0)
        : [];
    },
    SET_REPARACIONES_DATA(state, { recibidos, espera_repuestos, agendado, terceros, en_proceso, finalizados }) {
      state.reparaciones.recibidos = recibidos || [];
      state.reparaciones.espera_repuestos = espera_repuestos || [];
      state.reparaciones.agendado = agendado || [];
      state.reparaciones.terceros = terceros || [];
      state.reparaciones.en_proceso = en_proceso || [];
      state.reparaciones.finalizados = finalizados || [];
    },
  },

  actions: {
    async getVehiculosUsados() {
      try {
        const getVehiculos = await fetch(`${API_URL}/usados/vehiculos`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return getVehiculos.json();
      } catch (error) {
        return {
          resultado: 0,
          msj:
            "Ocurrio un problema al ejecutar el metodo getVehiculosUsados: " +
            error.message,
        };
      }
    },

    async getVehiculosPrecios() {
      try {
        const response = await fetch(`${API_URL}/usados/usadosdycar`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return response.json();
      } catch (error) {
        return {
          exito: 0,
          messaje:
            "Ocurrio un problema al traer los vehiculos para gestion" +
            error.messaje,
        };
      }
    },

    async getMarcasUsados() {
      try {
        const getMarcas = await fetch(`${API_URL}/usados/marcas`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        const marcasUsados = await getMarcas.json();
        return marcasUsados;
      } catch (error) {
        return {
          resultado: 0,
          msj:
            "Ocurrio un problema al ejecutar el metodo getMarcasUsados: " +
            error.message,
        };
      }
    },

    async getPrecios() {
      try {
        const getPrecios = await fetch(`${API_URL}/usados/filtroPrecio`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return getPrecios.json();
      } catch (error) {
        return {
          exito: 0,
          msj:
            "Ocurrio un problema al ejecutar el metodo getPrecios: " +
            error.message,
        };
      }
    },

    async getInfo() {
      try {
        const getInfo = await fetch(`${API_URL}/usados/info`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return getInfo.json();
      } catch (error) {
        return {
          exito: 0,
          msj:
            "Ocurrio un problema al traer la información de los usados en gestión: " +
            error.message,
        };
      }
    },

    async sincronizar() {
      try {
        const sync = await fetch(`${API_URL}/usados/sincronizar`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return sync.json();
      } catch (error) {
        return {
          exito: 0,
          msj:
            "Ocurrio un problema al sincronizar los vehiculos: " +
            error.message,
        };
      }
    },

    async editarUsado({}, payload) {
      try {
        const result = await fetch(`${API_URL}/usados/editar`, {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
          body: JSON.stringify(payload),
        });

        return result.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al editar el vehiculo usado" + error.message,
        };
      }
    },

    async getPreciosVigentes() {
      try {
        const result = await fetch(`${API_URL}/usados/preciosVigentes`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });

        return result.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al traer precios vigentes" + error.message,
        };
      }
    },

    async publicarPreciosUsados({}, payload) {
      try {
        const publicarPrecios = await fetch(
          `${API_URL}/usados/publicarVehiculosFB`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: store.state.token,
            },
            body: JSON.stringify(payload),
          }
        );

        const response = await publicarPrecios.json();
        return response;
      } catch (error) {
        return {
          exito: 0,
          msj: "Fallo el metodo publicar precios usados.",
          error,
        };
      }
    },

    async publicarPreciosAutodealer({}, payload) {
      try {
        const publicarAutodealer = await fetch(
          `${API_URL}/usados/publicarPreciosAutodealer`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: store.state.token,
            },
            body: JSON.stringify(payload),
          }
        );
        return publicarAutodealer.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Ocurrió un error al ejecutar el método publicarPreciosAutodealer",
          error,
        };
      }
    },

    async inhabilitarVehiculo({}, payload) {
      const response = await fetch(`${API_URL}/usados/inhabilitar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async habilitarVehiculo({}, payload) {
      const response = await fetch(`${API_URL}/usados/habilitar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async getVehiculosInhabilitados() {
      const response = await fetch(`${API_URL}/usados/vehiculosInhabilitados`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
      });
      return response.json();
    },

    async getPermisoHabilitar() {
      const response = await fetch(`${API_URL}/usados/permisoHabilitar`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
      });
      return response.json();
    },

    async getReporteUsadosEntregados({}, payload) {
      const response = await fetch(`${API_URL}/usados/reportes/usados-entregados`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },


    async getUsadosFirebase({}, payload) {
      const response = await fetch(`${API_URL}/usados/imagenes/vehiculos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    async actualizarImagenesVehiculo({}, payload) {
      const response = await fetch(`${API_URL}/usados/imagenes/actualizar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: store.state.token,
        },
        body: JSON.stringify(payload),
      });

      return response.json();
    },

    // ============================================================================
    // Reparaciones (Tablero Kanban)
    // ============================================================================

    async fetchReparaciones() {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones`, {
          method: "GET",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al obtener el tablero de reparaciones: " + error.message,
        };
      }
    },

    async crearReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones`, {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
          body: JSON.stringify(payload),
        });
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al crear la reparación: " + error.message,
        };
      }
    },

    async agregarTrabajoReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/trabajos`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          body: JSON.stringify({ items: payload.items || [], sucursal: payload.sucursal ?? null }),
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al crear el trabajo: " + error.message };
      }
    },

    async agregarItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items`,
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({ categoria: payload.categoria, descripcion: payload.descripcion }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al crear el ítem: " + error.message };
      }
    },

    async editarTrabajoReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({ descripcion: payload.descripcion }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al editar el trabajo: " + error.message };
      }
    },

    async eliminarTrabajoReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al eliminar el trabajo: " + error.message };
      }
    },

    async eliminarItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al eliminar el ítem: " + error.message };
      }
    },

    async editarItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({ descripcion: payload.descripcion }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al editar el ítem: " + error.message };
      }
    },

    async completarItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}/completar`,
          {
            method: "PATCH",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({ Completado: payload.Completado }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al confirmar el ítem: " + error.message };
      }
    },

    async crearAplicacionRepuesto({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}/aplicacion`,
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al crear la aplicación: " + error.message };
      }
    },

    async getComentariosItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}/comentarios`,
          {
            method: "GET",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al obtener comentarios: " + error.message };
      }
    },

    async agregarComentarioItemReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/trabajos/${payload.trabajoId}/items/${payload.itemId}/comentarios`,
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({ comentario: payload.comentario }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al agregar comentario: " + error.message };
      }
    },

    async agendarReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/agendar`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          body: JSON.stringify({
            fecha: payload.fecha,
            hora: payload.hora,
            ...(payload.sucursal ? { sucursal: payload.sucursal } : {}),
            ...(payload.recepcionistaId ? { recepcionistaId: payload.recepcionistaId } : {}),
            ...(payload.tiempoEstimado ? { tiempoEstimado: payload.tiempoEstimado } : {}),
            ...(Array.isArray(payload.trabajoIds) ? { trabajoIds: payload.trabajoIds } : {}),
            ...(Array.isArray(payload.manoObraItemIds) ? { manoObraItemIds: payload.manoObraItemIds } : {}),

          }),
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al agendar: " + error.message };
      }
    },

    async getDisponibilidadReparacion({}, payload) {
      try {
        const params = new URLSearchParams({
          fecha: payload.fecha,
          sucursal: payload.sucursal,
          recepcionistaId: payload.recepcionistaId,
          tiempoEstimado: payload.tiempoEstimado,
        });
        if (payload.id) params.set("reparacionId", payload.id);
        if (payload.usadoId) params.set("usadoId", payload.usadoId);
        if (payload.turnoIdExcluir) params.set("turnoIdExcluir", payload.turnoIdExcluir);
        const response = await fetch(`${API_URL}/usados/reparaciones/disponibilidad?${params.toString()}`, {
          method: "GET",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al consultar disponibilidad: " + error.message };
      }
    },

    async getRecepcionistasReparacion({}, payload) {
      try {
        const params = new URLSearchParams({ sucursal: payload.sucursal });
        const response = await fetch(`${API_URL}/usados/reparaciones/recepcionistas?${params.toString()}`, {
          method: "GET",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al consultar recepcionistas: " + error.message };
      }
    },

    async reprogramarReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/reschedule`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          body: JSON.stringify({
            reparacionTurnoId: payload.reparacionTurnoId,
            fecha: payload.fecha,
            hora: payload.hora,
            ...(payload.sucursal ? { sucursal: payload.sucursal } : {}),
            ...(payload.recepcionistaId ? { recepcionistaId: payload.recepcionistaId } : {}),
            ...(payload.tiempoEstimado ? { tiempoEstimado: payload.tiempoEstimado } : {}),
          }),
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al reprogramar: " + error.message };
      }
    },

    async cancelarReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/cancel`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          body: JSON.stringify({ reparacionTurnoId: payload.reparacionTurnoId }),
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al cancelar: " + error.message };
      }
    },

    async verificarReparacionEnProceso({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/verificar-en-proceso`,
          {
            method: "GET",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al verificar: " + error.message };
      }
    },

    async obtenerHistorialReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/historial`, {
          method: "GET",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al obtener el historial: " + error.message };
      }
    },

    async obtenerCostoTaller({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/costo-taller`, {
          method: "GET",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al obtener el costo de taller: " + error.message };
      }
    },

    async finalizarReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/finalizar`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al finalizar: " + error.message };
      }
    },

    async reenviarEmailReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}/reenviar-email`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al reenviar email: " + error.message };
      }
    },

    async getDestinatariosReparacion({}, payload = {}) {
      try {
        const params = new URLSearchParams();
        if (payload.sucursal_numero) params.set("sucursal_numero", payload.sucursal_numero);
        if (payload.tipo_alerta) params.set("tipo_alerta", payload.tipo_alerta);
        const qs = params.toString();
        const response = await fetch(`${API_URL}/usados/reparaciones/destinatarios${qs ? "?" + qs : ""}`, {
          method: "GET",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al obtener destinatarios: " + error.message };
      }
    },

    async altaDestinatarioReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/destinatarios`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          body: JSON.stringify(payload),
        });
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al crear destinatario: " + error.message };
      }
    },

    async editarDestinatarioReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/destinatarios/${payload.id}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
            body: JSON.stringify({
              sucursal_numero: payload.sucursal_numero,
              tipo_alerta: payload.tipo_alerta,
              email: payload.email,
              nombre: payload.nombre ?? null,
              telefono: payload.telefono ?? null,
            }),
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al editar destinatario: " + error.message };
      }
    },

    async bajaDestinatarioReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/destinatarios/${payload.id}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al dar de baja destinatario: " + error.message };
      }
    },

    async reactivarDestinatarioReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/destinatarios/${payload.id}/reactivar`,
          {
            method: "PATCH",
            headers: { "Content-Type": "Application/json", Authorization: store.state.token },
          }
        );
        return response.json();
      } catch (error) {
        return { exito: 0, msj: "Error al reactivar destinatario: " + error.message };
      }
    },

    async limpiarReparacion({}, payload) {
      try {
        const response = await fetch(`${API_URL}/usados/reparaciones/${payload.id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "Application/json",
            Authorization: store.state.token,
          },
        });
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al limpiar la reparación: " + error.message,
        };
      }
    },

    async getOrdenesServicioReparacion({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/ordenes-servicio`,
          {
            method: "GET",
            headers: {
              "Content-Type": "Application/json",
              Authorization: store.state.token,
            },
          }
        );
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al obtener órdenes de servicio: " + error.message,
        };
      }
    },

    // -----------------------------------------------------------------------
    // Peritaje (archivo PDF o imagen)
    // -----------------------------------------------------------------------
    async subirPeritaje({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/peritaje`,
          {
            method: "POST",
            headers: {
              "Content-Type": "Application/json",
              Authorization: store.state.token,
            },
            body: JSON.stringify({
              archivo: payload.archivo,
              nombreArchivo: payload.nombreArchivo,
              usadoId: payload.usadoId,
              Empresa: payload.Empresa,
            }),
          }
        );
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al subir peritaje: " + error.message,
        };
      }
    },

    async eliminarPeritaje({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/peritaje`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "Application/json",
              Authorization: store.state.token,
            },
          }
        );
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al eliminar peritaje: " + error.message,
        };
      }
    },

    async obtenerPeritaje({}, payload) {
      try {
        const response = await fetch(
          `${API_URL}/usados/reparaciones/${payload.id}/peritaje`,
          {
            method: "GET",
            headers: {
              "Content-Type": "Application/json",
              Authorization: store.state.token,
            },
          }
        );
        return response.json();
      } catch (error) {
        return {
          exito: 0,
          msj: "Error al obtener peritaje: " + error.message,
        };
      }
    },
  },
};
